const marquees = document.querySelectorAll('.js-marquee');

export const marquee = () => {
	marquees.forEach((marquee) => {
		const marqueeContent = marquee.querySelector('.marquee__content');
		// Important for a seamless animation when cloning content
		marqueeContent.classList.add('marquee--animation');

		if (marquee.dataset.separator) {
			const marqueeItems = marqueeContent.querySelectorAll('.marquee__item');

			marqueeItems.forEach((item) => {
				const separator = document.createElement('li');
				separator.classList.add('marquee__separator');
				separator.textContent = marquee.dataset.separator;
				item.after(separator);
			});
		}

		const copyContent = marqueeContent.cloneNode(true);

		marquee.append(copyContent);
	});
};
